import pdfMake from 'pdfmake/build/pdfmake';
import {Content, PageSize, TDocumentDefinitions} from "pdfmake/interfaces";
import {geoString} from '../helpers';
import {store} from "../redux/store";
import htmlToPdfmake from "html-to-pdfmake"
import {getColor} from "../assets/colors";

const fonts = require('./fonts/fonts');

type PageSizePro = "EXECUTIVE" | "FOLIO" | "LEGAL" | "LETTER" | "58mm" | "80mm"
export async function htmlToPDF(html:any, size?:PageSizePro | string, encabezado?:boolean) {
    let compania = store.getState().companias.data;
    let {uiColor} = store.getState().auth.user ?? {};
    let color = getColor(uiColor)

    pdfMake.tableLayouts = {
        customLayout: {
            // vLineWidth: function (i, node) {
            //     return 0;
            // },
            // hLineWidth: function (i, node) {
            //     return 0;
            // },
            paddingTop: function (i) {
                return 0
            },
            paddingBottom: function (i) {
                return 0
            },
            paddingLeft: function (i) {
                return 0
            },
            paddingRight: function (i) {
                return 0
            },
        }
    }



    var val = htmlToPdfmake(`${
        (html ?? "")
           .replaceAll("<table ", "<table data-pdfmake=\"{&quot;layout&quot;:&quot;noBorders&quot;}\" ")
            .replaceAll("line-height: normal;", "")
    }`,{
        tableAutoSize:true,
        defaultStyles:{
            span: {
                font: 'Calibri',
            },
            table: {margin:0, lineHeight:1},
        },
        ignoreStyles:[
            "font-family", "font"
            // , "line-height"
        ],
        removeExtraBlanks: true
    });

    pdfMake.vfs = fonts.pdfMake.vfs;
    pdfMake.fonts = {
        'Calibri': {
            normal: `Calibri_Regular.ttf`,
            bold: `Calibri_Bold.ttf`,
            italics: `Calibri_Light_Italic.ttf`,
            bolditalics: `Calibri_Bold_Italic.ttf`
        },
    }

    function buildHeader() {
        let enc: any[] = []
        if(encabezado){
            if(["58mm", "80mm"].includes(size ?? "")){
                enc = [
                    (compania?.logo ?  { image: 'logo', fit: [70, 50], marginLeft:((78.063 + parseInt(size!)) / 2) - 35, marginBottom:5, marginTop:5 } : { text:"" , marginTop:10}),
                    {text: compania?.nombre??"", alignment: 'center', fontSize:9, color:uiColor},
                    {
                        text: (compania?.rnc ? geoString("rnc",true) +": "+compania?.rnc+" \n" : "")+
                            (compania?.telefono ? "Tel: "+compania?.telefono+" " : "")+ (compania?.telefono2 ? " / "+compania?.telefono2+" \n" : "")+
                            (compania?.direccion ? compania?.direccion+" \n" : ""),
                        alignment: 'center',
                        // fontSize:
                        italics: true
                    },
                ]
                return enc
            }


            enc = [
                {
                    layout:"noBorders",
                    table: {
                        widths: ['*', '*'],
                        body: [
                            [
                                compania?.logo ?
                                    {
                                        image: "logo",
                                        // width: 150,
                                        fit: [130, 50],
                                        // opacity: 0.5,
                                        marginTop: 7
                                    }:{},
                                [
                                    {text: compania?.nombre ?? "", alignment:"right", fontSize:17, color:color.primary.main},
                                    ...(compania?.rnc ? [{text: "RNC: "+compania?.rnc, alignment: "right"}]: []),
                                    {text: [
                                            "Tel: "+ compania?.telefono ?? "",
                                            (compania?.telefono2 ? " / "+compania.telefono2 : ""),
                                        ], alignment:"right", fontSize:10},

                                    {text: compania?.direccion ?? "" , alignment:"right", fontSize:10},
                                ]
                            ],
                        ]
                    }
                },
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 555,
                            y2: 10,
                            lineWidth: 0.5,
                            lineColor:"#d3d3d3",
                            strokeOpacity:0.5
                        }
                    ],
                    marginBottom:10,
                }
            ]
        }

        return enc
    }


    let docDefinition:TDocumentDefinitions = {
        pageMargins: ["58mm", "80mm"].includes(size ?? "")? 2:undefined,
        info: {
            title: 'Contrato',
            author: 'dsegura.net',
            creator: 'prestamistapp.com',
        },
        pageSize: (():PageSize => {
            if(size === "58mm" || size === "80mm"){
                return {

                    width: 78.063 + parseInt(size),
                    height:"auto"
                }
            }
          return ((size?.length ?? "") > 2 ? size: "LETTER") as PageSize
        })(),
        // pageOrientation:'landscape',
        content: [
            ...buildHeader(),
            (val as Content)
        ],

        styles: {

            table: {
                margin: [0, 0, 0, 0],
            },
        },
        images:{
            logo: compania?.logo ?? ""
        },

        defaultStyle: {
            fontSize: ["58mm", "80mm"].includes(size ?? "")? 8: 12,
            lineHeight: ["58mm", "80mm"].includes(size ?? "")? 2: 1.3,
            font: 'Calibri',
            // alignment: 'center'
        }
    }


    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    return Promise.resolve(pdfDocGenerator);
}


